import { useQuery } from "@tanstack/react-query";
import { getDealsGroupedByCompanies } from "@/api";
import { CompanyDealData } from "@/types";

export const useCompanyDealData = () => {
  const query = useQuery<CompanyDealData[]>({
    queryKey: ["companyDealData"],
    queryFn: () => getDealsGroupedByCompanies(),
    staleTime: 1000 * 60 * 5,
  });

  return {
    ...query,
    data: query.data || [],
  }
};